import { render, staticRenderFns } from "./scroll-load.vue?vue&type=template&id=eeb2c712"
import script from "./scroll-load.vue?vue&type=script&lang=js"
export * from "./scroll-load.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports